var render = function render(_c,_vm){return _c('div',{staticClass:"multiselect-selected-item"},[_vm._t("default"),_c('button',{on:{"click":function($event){_vm.listeners['click:remove'] ? _vm.listeners['click:remove']() : null}}},[_c('i',{staticClass:"budicon-cross-ui"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }